export default "__VITE_ASSET__QGPpedES__"